<template>
  <div>
    <div class="intro-y flex items-center mt-8" />
    <div class="grid grid-cols-12 gap-3">
      <!-- BEGIN: Profile Menu -->
      <div
        class="col-span-12 lg:col-span-4 xxl:col-span-3 flex lg:block flex-col-reverse"
        >
        <div class="intro-y box mt-1">
          <div class="p-3 border-t border-gray-200 dark:border-dark-5">
            <div class="text-3xl text-theme-1 font-medium leading-none">
              Login or sign up
            </div>
          </div>
          <div class="p-5 border-t flex">
            <button
              type="button"
              class="button button--sm block bg-theme-1 text-white"
              @click="$router.push('login')"
            >
              Login
            </button>
            <button
              :style="{ 'padding-top': '0.25rem',
                        'padding-bottom': '0.25rem',
                        'padding-left': '2rem',
                        'padding-right': '2rem'
              }"
              type="button"
              class="button button--sm border text-gray-700 dark:border-dark-5 dark:text-gray-300 ml-auto"
              @click="$router.push('register')"
            >
              Sign up
            </button>
          </div>
            <div class="font-medium">

              <img

                  :src="require(`@/assets/images/convert_image_vertical_85.svg`)"

              />

            <div style = "color: rgb(128,128,128)" class="font-medium">
            
            <br> 
            <br>         
              <p class="font-italic">
                "The PMSTConverter platform is super easy and user friendly. The Excel output gave me quick and easy access to all the information I 
                needed" Jess.G  
              </p>
              <br>               
              <br> 
              <p class="font-italic">
                "A good example of innovation that saves us time and money, a welcome tool for the industry" Maddy.H  
              </p>
              <br>
              <br>
              <br>
            </div>

            
            </div>
        </div>
      </div>
      <!-- END: Profile Menu, 120px illustration.svg -->
      <!-- <img flex items-center px-5 py-3 border-b border-gray-200 dark:border-dark-5 -->
      <!--    alt="Midone Tailwind HTML Admin Template" -->
      <!--    class="-intro-x w-1/2 -mt-16" -->
      <!--    :src="require(`@/assets/images/convert_image.svg`)" -->
      <!--    style="margin-left: 120px;" col-span-12 lg:col-span-8 xxl:col-span-9 -->
      <!--/> -->
      <div class="col-span-12 lg:col-span-8 xxl:col-span-9 lg:block flex-col-reverse">
        
        <!-- BEGIN: Announcement -->
        <div class="intro-y box mt-1">
          <div
            class="p-3 border-t border-gray-200 dark:border-dark-5 border-b"
          >    
            <h2 class="text-3xl text-theme-1 font-medium leading-none">
              PMSTConverter
            </h2>
          </div>
          <div class="px-5">
            <div class="font-medium text-lg" />

            <br>Our service quickly converts the <a class="text-theme-1 dark:text-theme-10" href="https://environment.gov.au/epbc/protected-matters-search-tool" >EPBC Protected Matters Search Tool</a>  (PMST)
            results .pdf file into an editable Excel format for use in reporting - a task that can take hours costing hundreds of dollars. In addition, a summary of the 
            <a class="text-theme-1 dark:text-theme-10" href="http://www.environment.gov.au/cgi-bin/sprat/public/sprat.pl" >SPRAT</a> profile distribution and habitat preferences for
            the majority of the EPBC listed fauna and flora will be incorporated into the output saving you even more time and money.<br>

            <br>Unlike other online pdf converters, PMSTConverter puts each of the PMST listed species and associated information on separate rows and cells allowing 
            you to start using the information immediately.<br>

            <br>It only takes a few simple steps to convert your file: <br>

            <div class="font-medium">
              <br>Step 1: Login and provide us your preferred email address.
              <br>Step 2: Upload your PMST result .pdf file (unmodified).
              <br>Step 3: Confirm email address and payment details (${{ settings[0].product_price }} per file excluding GST - payments are made using the secure
              <a class="text-theme-1 dark:text-theme-10" href="https://stripe.com/au">STRIPE</a> payment platform).
              <br>Step 4: Download the converted file (and tax invoice) that is emailed to you. <br><br>
            </div>

            To see how easy the process is check out a video we posted on LinkedIn <a class="text-theme-1 dark:text-theme-10" href="https://www.linkedin.com/feed/update/urn:li:activity:6762125323518779393">here</a>.
            <br>

            <br>PMSTConverter is an Australian company backed by a team that has extensive experience undertaking environmental assessments. The development of this tool
            and secure platform came from our desire to reduce the amount of time wasted transcribing and compiling information needed to inform
            these assessments.<br>
                       
            <br>
            Stop wasting your time, expertise and money transcribing the PMST result
            pdf. Login or sign up now to get started. <br><br>

            Following some recent feedback we are now offering discounts to convert ten or more PMST results pdf files.
            To take advantage of this offer contact the team using the methods listed on the Contact Us tab.

            <br><br>

            For more information or to request an example of the output,
            email the team at <a class="text-theme-1 dark:text-theme-10" href="mailto:info@PMSTConverter.com">info@PMSTConverter.com</a>.

            <div class="text-gray-700 dark:text-gray-600 mt-2" />
            <div class="flex items-center mt-5" />
          </div>
        </div>
      </div>
    </div>

    <div class="col-span-12 lg:col-span-12 xxl:col-span-12">
      <!-- BEGIN: Announcement -->
      <div class="intro-y box mt-5">
        <div
          class="flex items-center px-5 py-3 border-b border-gray-200 dark:border-dark-5"
        >
          <h3 class="text-2xl text-theme-1 font-medium leading-none">
            Some of our clients
          </h3>
        </div>
        <div class="px-5">
        </div>
          <div class="font-medium">

            <img

              :src="require(`@/assets/images/Clients_Banner.svg`)"
              align = "centre"

            />
          </div>

        </div>
      </div>


  </div>
</template>

<script>

import axios from "axios";

export default {
  data: function() {
    return {
      settings: [
        {
          product_price: undefined
        }
      ],
    };
  },
  mounted() {
    this.getSettings()
  },
  methods: {
    getSettings() {
      axios
          .get("pmst/settings/")
          .then(response => {
            let data = response.data;
            this.settings = data;
          })
          .catch(function(error) {
            console.error(error.response);
          });
    },
    prevAnnouncement() {
      this.$refs["announcement"].prev();
    },
    nextAnnouncement() {
      this.$refs["announcement"].next();
    },
    prevNewProjects() {
      this.$refs["new-projects"].prev();
    },
    nextNewProjects() {
      this.$refs["new-projects"].next();
    },
    prevTodaysSchedule() {
      this.$refs["todays-schedule"].prev();
    },
    nextTodaysSchedule() {
      this.$refs["todays-schedule"].next();
    }
  }
};
</script>
<style>
.button.button--sm.block.bg-theme-1.text-white {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 2rem;
  padding-right: 2rem;
}
.button.button--sm.border.text-gray-700.dark.border-dark-5.dark.text-gray-300.ml-auto {
   padding-top: 0.25rem;
   padding-bottom: 0.25rem;
   padding-left: 2rem;
   padding-right: 2rem;
 }
</style>
